export const isDev = (): boolean => {
    const { hostname } = window.location;
    const matches = /(dev|local)?\.?magicline\.com/.exec(hostname);

    if (/localhost/.exec(hostname)) {
        return true;
    }

    if (matches) {
        const [, env] = matches;

        if (env === 'local' || env === 'dev') {
            return true;
        }
    }

    return false;
};

export const getQueryParams = (key: string) => {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
};
